import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, tabulatorGet, downloadBlobGet, fetchTextGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon,PaperClipIcon} from "../../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { DateTime } from "luxon";
import UtilContext from '../../../components/UtilContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import ReactDOMServer from 'react-dom/server';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { getModuleSettingValue, getTrngSemaforColor, getSemaforColorClass } from '../../../utils/moduleSettings';
import { primeMultiSelectHeaderFilter } from '../../../utils/primeMultiSelectHeaderFilter';
import { extractSafePaginationParams, createDedupedAjaxRequest, cleanSorters } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import {
  applyCompanyCertPagedMutationOverlay,
  classifyCompanyCertListMutation,
  collectCompanyCertChangedFields,
  SESSION_SAFE_UPDATE,
  SESSION_TOMBSTONE,
} from '../../../utils/trainingCompanyCertStateListSync';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../../utils/serviceTaskExport';
import { xlsxDownloadFilename } from '../../../utils/exportExcelNaming';
import { openCompanyCertRecordProtocol } from './TrainingCompanyCertRecordDetail';
import {
  isCompanyCertificateParentRow,
  readTabulatorHeaderFilterEntries,
  resolveCardDeactivationDate,
  resolveCardResponsibleName,
  resolveCatalogDescription,
  resolveCertificateTreeAuditRow,
  resolveIssuanceDescription,
  resolveIssuanceEndOfValidity,
  resolveIssuanceExpirationBucket,
  resolveIssuanceFiles,
  resolveIssuanceStartOfValidity,
  resolveIssuanceStateLabel,
} from '../../../utils/companyCertificateCurrentRecord';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
import {
  appendAuditFieldsToColumnLayout,
  buildAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
  TABULATOR_AUDIT_PROFILES,
} from '../../../utils/tabulatorAuditColumns';

const TRAINING_COMPANY_CERT_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'company.name': 'TrainingCompanyList.Column.Name',
  'description': 'Common.Description',
  'name': 'Common.CertificateName',
  'custom_start_of_validity': 'Common.ValidFrom',
  'custom_end_of_validity': 'Common.ValidTo',
  'custom_expiration': 'Common.Expiration',
  'record_description': 'Common.CertificateDescription',
  'certificate_status': 'Common.CertificateStatus',
  'responsible.name': 'Common.Column.Responsible',
  'state': 'Common.Status',
  'id': 'TrainingCompanyList.Column.Name',
  'protocol': 'Common.Protocol',
});

export const TRAINING_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE = Object.freeze({
    'company.name': true,
    name: true,
    description: true,
    record_description: true,
    calibration_company_id: true,
    custom_start_of_validity: true,
    custom_end_of_validity: true,
    custom_expiration: true,
    certificate_status: true,
    'responsible.name': true,
    protocol: true,
    state: true,
    created_at: true,
    updated_at: true,
});

export const TRAINING_COMPANY_CERT_HEADER_FILTER_FIELDS = Object.freeze([
    'company.name',
    'name',
    'description',
    'custom_start_of_validity',
    'custom_end_of_validity',
    'custom_expiration',
    'record_description',
    'certificate_status',
    'responsible.name',
    'protocol',
    'state',
    'created_at',
    'updated_at',
]);

export function readTrainingCompanyCertHeaderFilterValue(table, field, headerFilters) {
    const list = headerFilters || [];
    let columnValue;
    let hasColumnRead = false;
    if (table?.getColumn) {
        try {
            const col = table.getColumn(field);
            if (col && typeof col.getHeaderFilterValue === 'function') {
                columnValue = col.getHeaderFilterValue();
                hasColumnRead = true;
            }
        } catch (_) {
            hasColumnRead = false;
        }
    }
    if (hasColumnRead && columnValue !== undefined && columnValue !== null) {
        return columnValue;
    }
    const fromList = list.find((f) => f?.field === field);
    return fromList?.value;
}

function normalizeTrainingCompanyCertHeaderFilterValue(raw) {
    if (raw === undefined || raw === null) return '';
    return (Array.isArray(raw) ? raw.join(',') : String(raw)).trim();
}

export function mapTrainingCompanyCertHeaderFiltersToQuery(headerFilters, table = null) {
    const extra = {};
    const list = headerFilters || [];
    const fields = new Set();
    if (table) {
        TRAINING_COMPANY_CERT_HEADER_FILTER_FIELDS.forEach((f) => fields.add(f));
    }
    list.forEach((f) => {
        if (f?.field !== undefined && f?.field !== null) fields.add(f.field);
    });
    fields.forEach((field) => {
        const raw = table
            ? readTrainingCompanyCertHeaderFilterValue(table, field, list)
            : list.find((f) => f?.field === field)?.value;
        const v = normalizeTrainingCompanyCertHeaderFilterValue(raw);
        if (v !== '') extra['filter_' + field] = v;
    });
    return extra;
}
export default function TrainingCompanyCertStateList({ preview = null, preview_period = null, preview_segment = null }) {
const { t, locale } = useContext(LocaleContext);

    const [state,dispatch] = useContext(DatabaseContext);
    const module_settings = state.module_settings || [];
    const showExcludedCompaniesByState = getModuleSettingValue(module_settings, 'training', 'show_excluded_training_companies_list_by_state', '0');
    // Canonical cert-dea key (seeded for training); do NOT reuse show_deactivated_in_lists (card toggle).
    const showDeactivatedCertsByState = getModuleSettingValue(module_settings, 'training', 'show_deactivated_certs_list_by_state', '0');
    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview,getDateFormat, getUserColor, getUserInitials, openChosenNotificationPreferences} = useContext(UtilContext);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFmt = `${dateFmt} HH:mm`;

    const savedHScrollRef = useRef({ left: 0, pending: false });
    const tableBuiltRef = useRef(false);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const lastResponseRef = useRef(null);
    const isRestoringRef = useRef(false);
    const pendingInvalidationRef = useRef(false);
    const mutationOverlayRef = useRef(new Map());
    const listMountedRef = useRef(true);
    const restartQueuedRef = useRef(false);
    const ajaxGenerationRef = useRef(0);
    const confirmedQueryRef = useRef({ filters: [], sorters: [] });
    const sessionQueryActiveRef = useRef(false);
    const lastContainerHeightRef = useRef(0);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const toolbarSearchRef = useRef('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...TRAINING_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE }));


    const [maskVisible, setMaskVisible] = useState(false);
    const [tableSessionKey, setTableSessionKey] = useState(0);
const [editFormGauge, setEditFormGauge] = useState([]);
    const [trainingTypesList, setTrainingTypesList] = useState([]);

    useEffect(() => {
        getRequest("/api/training_types?minimal=1")
            .then((r) => setTrainingTypesList(r?.data ?? r ?? []))
            .catch(() => {});
    }, []);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const tableContainerRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const isTableVisible = useCallback(() => {
        const el = tableContainerRef.current;
        if (el && el.offsetParent != null && el.clientHeight > 0) return true;
        const table = getTable();
        const tel = table?.getElement?.() ?? table?.element;
        return !!(tel && tel.offsetParent != null && tel.clientHeight > 0);
    }, [getTable]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const snapshotConfirmedQuery = useCallback(() => {
        const table = getTable();
        confirmedQueryRef.current = {
            filters: readTabulatorHeaderFilterEntries(table),
            sorters: cleanSorters(table?.getSorters?.() || []),
        };
    }, [getTable]);

    const restartFullProgressiveSession = useCallback(() => {
        if (!listMountedRef.current || restartQueuedRef.current) return;
        snapshotConfirmedQuery();
        sessionQueryActiveRef.current = true;
        ajaxGenerationRef.current += 1;
        pendingInvalidationRef.current = false;
        mutationOverlayRef.current = new Map();
        restartQueuedRef.current = true;
        completedCacheRef.current.clear();
        lastResponseRef.current = null;
        inFlightRef.current = { sig: null, promise: null };
        tableBuiltRef.current = false;
        isRestoringRef.current = true;
        const table = getTable();
        if (typeof table?.destroy === 'function') table.destroy();
        ref.current = null;
        setTableSessionKey((key) => key + 1);
    }, [getTable, snapshotConfirmedQuery]);

    const requestFullProgressiveSessionRestart = useCallback(() => {
        if (!listMountedRef.current) return;
        if (!isTableVisible()) {
            pendingInvalidationRef.current = true;
            return;
        }
        restartFullProgressiveSession();
    }, [isTableVisible, restartFullProgressiveSession]);

    const getLoadedRowComponent = useCallback((id) => {
        const table = getTable();
        if (!table || typeof table.getRow !== 'function' || id == null || id === '') return null;
        try {
            const row = table.getRow(id);
            return row && row !== false ? row : null;
        } catch (_e) {
            return null;
        }
    }, [getTable]);

    const applySafeCompanyCertPatch = useCallback((canonicalRow) => {
        const id = canonicalRow?.id;
        const rowComponent = getLoadedRowComponent(id);
        if (!rowComponent || typeof rowComponent.update !== 'function' || !canonicalRow) {
            requestFullProgressiveSessionRestart();
            return;
        }
        const next = { ...canonicalRow, _children: canonicalRow._children ?? [] };
        rowComponent.update(next);
        mutationOverlayRef.current.set(String(id), next);
    }, [getLoadedRowComponent, requestFullProgressiveSessionRestart]);

    useEffect(() => {
        listMountedRef.current = true;
        return () => { listMountedRef.current = false; };
    }, []);

    useEffect(() => {
        const el = tableContainerRef.current;
        if (!el || typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver(() => {
            const h = el.clientHeight;
            const visible = h > 0 || isTableVisible();
            if (visible) {
                const wasHidden = lastContainerHeightRef.current <= 0;
                lastContainerHeightRef.current = Math.max(h, 1);
                if (pendingInvalidationRef.current) {
                    requestAnimationFrame(() => restartFullProgressiveSession());
                } else if (wasHidden) {
                    requestAnimationFrame(() => getTable()?.redraw?.(true));
                }
            } else {
                lastContainerHeightRef.current = 0;
            }
        });
        ro.observe(el);
        return () => ro.disconnect();
    }, [getTable, isTableVisible, restartFullProgressiveSession]);

    const listType = 'training';
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const isMyType = (p) => p?.type === listType;
      const sessionContext = () => {
        const table = getTable();
        return {
          toolbarSearch: toolbarSearchRef.current,
          activeHeaderFilters: readTabulatorHeaderFilterEntries(table),
          activeSorters: cleanSorters(table?.getSorters?.() || []),
          isRowLoaded: (rid) => Boolean(getLoadedRowComponent(rid)),
        };
      };
      const invalidateSession = () => {
        requestFullProgressiveSessionRestart();
      };
      const onCreated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.created', id)) return;
        invalidateSession();
      };
      const onUpdated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.updated', id)) return;
        const previous = (() => {
          try {
            return getLoadedRowComponent(id)?.getData?.() ?? null;
          } catch (_e) {
            return null;
          }
        })();
        getRequest(`/api/company_certificates/${id}`).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          if (!row?.id) {
            invalidateSession();
            return;
          }
          const changedFields = collectCompanyCertChangedFields(previous, row, { implicitAudit: true });
          const decision = classifyCompanyCertListMutation({
            detail: { operation: 'update', id, row, previous, changedFields },
          }, sessionContext());
          if (decision === SESSION_SAFE_UPDATE) {
            applySafeCompanyCertPatch(row);
            return;
          }
          invalidateSession();
        }).catch(() => invalidateSession());
      };
      const onDeleted = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.deleted', id)) return;
        mutationOverlayRef.current.set(String(id), SESSION_TOMBSTONE);
        try {
          getLoadedRowComponent(id)?.delete?.();
        } catch (_e) {}
        invalidateSession();
      };
      const onActivated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.activated', id)) return;
        invalidateSession();
      };
      const onDeactivated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.deactivated', id)) return;
        invalidateSession();
      };
      channel.bind('company_certificate.created', onCreated);
      channel.bind('company_certificate.updated', onUpdated);
      channel.bind('company_certificate.deleted', onDeleted);
      channel.bind('company_certificate.activated', onActivated);
      channel.bind('company_certificate.deactivated', onDeactivated);
      return () => {
        channel.unbind('company_certificate.created', onCreated);
        channel.unbind('company_certificate.updated', onUpdated);
        channel.unbind('company_certificate.deleted', onDeleted);
        channel.unbind('company_certificate.activated', onActivated);
        channel.unbind('company_certificate.deactivated', onDeactivated);
      };
    }, [applySafeCompanyCertPatch, getLoadedRowComponent, getTable, listType, requestFullProgressiveSessionRestart]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = {
            type: 'training',
            show_excluded_companies: showExcludedCompaniesByState === '1' ? '1' : '0',
            show_deactivated_certs: showDeactivatedCertsByState === '1' ? '1' : '0',
            ...extractSafePaginationParams(paramsFromTabulator),
        };
        if (extra.size === undefined || extra.size === null) extra.size = pageSizePc;
        if (sessionQueryActiveRef.current) {
            Object.assign(extra, mapTrainingCompanyCertHeaderFiltersToQuery(confirmedQueryRef.current.filters, null));
            const confirmedSorters = cleanSorters(confirmedQueryRef.current.sorters || []);
            if (confirmedSorters.length) extra.sorters = JSON.stringify(confirmedSorters);
        } else {
            const table = getTable();
            const hf = readTabulatorHeaderFilterEntries(table);
            Object.assign(extra, mapTrainingCompanyCertHeaderFiltersToQuery(hf, table));
            const sorters = cleanSorters(paramsFromTabulator?.sorters ?? table?.getSorters?.() ?? []);
            if (sorters?.length) extra.sorters = JSON.stringify(sorters);
        }
        const search = String(toolbarSearchRef.current ?? '').trim();
        if (search !== '') extra.toolbar_search = search;
        if (preview_period?.dateFrom) extra.date_from = preview_period.dateFrom;
        if (preview_period?.dateTo) extra.date_to = preview_period.dateTo;
        if (preview_segment) extra.preview_segment = preview_segment;
        if (preview != null) extra.preview = String(preview);
        return extra;
    }, [pageSizePc, getTable, showExcludedCompaniesByState, showDeactivatedCertsByState, preview_period, preview_segment, preview]);

    const fetchPaged = useCallback((url, merged) => {
        return tabulatorGet(url, merged).then((r) => ({
            data: r?.data ?? [],
            last_page: r?.last_page ?? 1,
            total: r?.total ?? 0,
            current_page: r?.current_page ?? merged?.page ?? 1,
        }));
    }, []);

    const buildRequestParamsRef = useRef(buildRequestParams);
    buildRequestParamsRef.current = buildRequestParams;
    const getBuildRequestParams = useCallback((paramsFromTabulator) => buildRequestParamsRef.current(paramsFromTabulator), []);

    const ajaxRequestFunc = useCallback((url, config, params) => {
        const generation = ajaxGenerationRef.current;
        if (pendingInvalidationRef.current && !isTableVisible()) {
            return Promise.resolve({
                data: [],
                last_page: 1,
                current_page: Number(params?.page) || 1,
                total: 0,
            });
        }
        return createDedupedAjaxRequest(
            getBuildRequestParams,
            fetchPaged,
            inFlightRef,
            completedCacheRef,
            isRestoringRef,
            lastResponseRef,
        )(url, config, params).then((data) => {
            if (generation !== ajaxGenerationRef.current) {
                return {
                    data: [],
                    last_page: data?.last_page ?? 1,
                    total: 0,
                    current_page: Number(params?.page) || 1,
                };
            }
            return data;
        });
    }, [fetchPaged, getBuildRequestParams, isTableVisible]);

    const getPrintColumnsOrder = useCallback(() => {
        const table = getTable();
        const allowed = Object.keys(TRAINING_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE);
        const fallback = () => allowed.filter((f) => columnsVisible[f] !== false);
        if (!table?.getColumns) return fallback();
        const allowedSet = new Set(allowed);
        const out = [];
        const seen = new Set();
        try {
            table.getColumns().forEach((col) => {
                const field = col.getField?.() ?? col.getDefinition?.()?.field;
                if (!field || !allowedSet.has(field)) return;
                if (columnsVisible[field] === false) return;
                if (seen.has(field)) return;
                seen.add(field);
                out.push(field);
            });
        } catch (_) {
            return fallback();
        }
        return out.length > 0 ? out : fallback();
    }, [getTable, columnsVisible]);

    const buildCompanyCertExportQueryString = useCallback((opts = {}) => {
        const extra = buildRequestParams({});
        return buildExportQueryStringFromParams(extra, opts);
    }, [buildRequestParams]);

    const runCompanyCertPrint = useCallback(async () => {
        try {
            setDialogText?.(t('Common.PreparingPrint'));
            setVisible?.(true);
            const suffix = buildCompanyCertExportQueryString({
                includePrintColumns: true,
                printColumns: getPrintColumnsOrder(),
            });
            const html = await fetchTextGet(`/api/company_certificates/export/print${suffix}`);
            if (!openPrintHtmlWindow(html)) {
                toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.PrintTitle'), detail: t('Common.EnablePopups'), life: 4000 });
            }
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: t('DepartmentList.Toast.PrintTitle'), detail: e?.message || t('Common.PrintFailed'), life: 4500 });
        } finally {
            setVisible?.(false);
        }
    }, [buildCompanyCertExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast]);

    const exportCompanyCertXlsx = useCallback(async () => {
        try {
            setDialogText?.(t('Common.PreparingExport'));
            setVisible?.(true);
            const suffix = buildCompanyCertExportQueryString({
                includePrintColumns: true,
                printColumns: getPrintColumnsOrder(),
            });
            const { blob, filename } = await downloadBlobGet(`/api/company_certificates/export/xlsx${suffix}`, xlsxDownloadFilename('company-certificates'));
            triggerBlobDownload(blob, filename || xlsxDownloadFilename('company-certificates'));
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: t('Common.Export'), detail: e?.message || t('Common.ExportFailed'), life: 4500 });
        } finally {
            setVisible?.(false);
        }
    }, [buildCompanyCertExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast]);

    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

      function matchAny(data, filterParams) {
        //data - the data for the row being filtered
        //filterParams - params object passed to the filter
        //RegExp - modifier "i" - case insensitve
    
        var match = false;
        const regex = RegExp(filterParams.value, 'i');
    
        for (var key in data) {
            if (regex.test(data[key]) === true) {
                match = true;
            }
        }
        return match;
      }

      function searchTable(){
        toolbarSearchRef.current = String(searchValue ?? '').trim();
        setSearchIconColor("active");
        captureHScroll();
        requestFullProgressiveSessionRestart();
        setVisibleSearch(false);
      }
    
        const accept = () => {
            let rows_to_delete = [];
            rows_to_delete = ref.current.getSelectedData();
            rows_to_delete.forEach(element => {
              console.log(element);
              deleteRequest(`/api/training_types/${element.id}`)
                  .then((response) => {
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                  }).catch((reason) => {
                      alert(reason);
                      toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
                  })
            });
            getRequest("/api/training_types").then((r) => {
              setTrainingTypesList(r?.data ?? r ?? []);
            }).catch(() => {});
        }
    
        const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };
    
      const rowClick = (e, row) => {
        console.log(e, row);
     };
    
      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
          if(data.length === 0){
            setInsertIcon(true);
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            setInsertIcon(false);
            setEditIcon(false);
            setCopyIcon(false);
            setDeleteIcon(false);
          }
      };
      function TrainingCompanyNameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.company.name}</div>;
        return "";
      } 

      function NameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.name}</div>;
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1)return <div className='training_name'>Prvotný certifikát</div>;
                    else return <div className='training_name'>{parent_array.length-1-i}. Opakovaný certifikát</div>;
                }
            }
            return <div className='training_name'>{parent._row.data.name}</div>;
        }
        return "";
      }  
  
      function viewFile(file_id){
          return openCompanyCertRecordProtocol(file_id, {
              request: getRequest,
              preview: openFilePreview,
              onError: () => {
                  toast?.current?.show({
                      severity: 'warn',
                      summary: t('Common.Rejected'),
                      detail: t('Common.Toast.ActionFailedDetail'),
                      life: 3000,
                  });
              },
          });
      }

        function Protocol(props) {
          const rowData = props.cell.getRow().getData();
          const files = resolveIssuanceFiles(rowData);
          if(files.length > 0) return <div className='flex flex-row'>{files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>;
          return "";
      }

      function EndOfValidity(props){
          const rowData = props.cell.getRow().getData();
          const end = resolveIssuanceEndOfValidity(rowData);
          if(end) return DateTime.fromISO(end).toFormat(dateFmt);
          return <span className='text-red-500'>{t('Ui.R67.Necertifikovane')}</span>;
      }

      function StartOfValidity(props){
          const rowData = props.cell.getRow().getData();
          const start = resolveIssuanceStartOfValidity(rowData);
          if(start) return DateTime.fromISO(start).toFormat(dateFmt);
          return <span className='text-red-500'>{t('Ui.R67.Necertifikovane')}</span>;
      }

      function StateFormatter(props){
        return resolveIssuanceStateLabel(props.cell.getRow().getData());
      }

      function CatalogDescriptionFormatter(props){
        return resolveCatalogDescription(props.cell.getRow().getData());
      }

      function CertDescriptionFormatter(props){
        return resolveIssuanceDescription(props.cell.getRow().getData());
      }

      function cardFromRow(row) {
        const rowData = row?.getData?.() ?? {};
        if (isCompanyCertificateParentRow(rowData)) return rowData;
        return row?.getTreeParent()?._row?.data ?? row?.getTreeParent()?.getData?.() ?? null;
      }

      function CertificateStatusFormatter(props) {
        const card = cardFromRow(props.cell.getRow());
        const v = resolveCardDeactivationDate(card);
        return <span>{v ? t('Status.Deactivated') : 'Aktívny'}</span>;
      }

      function getStateLabel(rowData) {
        return resolveIssuanceStateLabel(rowData);
      }
      function startOfValidityDisplayStr(rowData) {
        const start = resolveIssuanceStartOfValidity(rowData);
        if (start) return DateTime.fromISO(start).toFormat(dateFmt);
        return '';
      }
      function endOfValidityDisplayStr(rowData) {
        const end = resolveIssuanceEndOfValidity(rowData);
        if (end) return DateTime.fromISO(end).toFormat(dateFmt);
        return '';
      }

      function ResponsibleNameFormatter(props) {
        const card = cardFromRow(props.cell.getRow());
        return <span>{resolveCardResponsibleName(card)}</span>;
      }

      function ExpirationFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const bucket = resolveIssuanceExpirationBucket(rowData);
        const color = getTrngSemaforColor(module_settings, bucket);
        const colorClass = getSemaforColorClass(color);
        return (
          <span className="inline-flex items-center gap-1.5">
            <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${colorClass}`} title={bucket} />
            <span>{bucket}</span>
          </span>
        );
      }
  
      const auditTailColumns = useMemo(
        () =>
          buildAuditTabulatorColumns({
            profile: TABULATOR_AUDIT_PROFILES.createdByUpdatedBy,
            includeId: false,
            dateFormat: dateFmt,
            dateTimeFormat: dateTimeFmt,
            getUserColor,
            getUserInitials,
            remotePassthrough: true,
            auditSourceFn: resolveCertificateTreeAuditRow,
          }),
        [dateFmt, dateTimeFmt, getUserColor, getUserInitials]
      );

      const [baseColumns] = useState([
        { title: '', field: 'id',visible:false},
        { title: t('TrainingCompanyList.Column.Name'), field: 'company.name',formatter: reactFormatter(<TrainingCompanyNameFormatter/>),headerFilter:"input",minWidth: 200, widthGrow:1},
        { title: t('Common.Description'), field: 'description', formatter: reactFormatter(<CatalogDescriptionFormatter/>), headerFilter:"input",minWidth: 200, widthGrow:1},
        { title: t('Common.CertificateName'), field: 'name',formatter: reactFormatter(<NameFormatter/>),headerFilter:"input",minWidth: 200, widthGrow:1},
        { title: t('Common.ValidFrom'), field: 'custom_start_of_validity', headerFilter: 'input', headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; const s = startOfValidityDisplayStr(rowData).toLowerCase(); return s.includes(String(headerValue).trim().toLowerCase()); }, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<StartOfValidity/>) },
        { title: t('Common.ValidTo'), field: 'custom_end_of_validity', headerFilter: 'input', headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; const s = endOfValidityDisplayStr(rowData).toLowerCase(); return s.includes(String(headerValue).trim().toLowerCase()); }, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<EndOfValidity/>) },
        { title: t('Common.Expiration'), field: 'custom_expiration', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.Expiration'), options: [{ label: t('Common.All'), value: "Všetko" }, { label: '61+', value: '61+' }, { label: '60-', value: '60-' }, { label: '45-', value: '45-' }, { label: '30-', value: '30-' }, { label: '15-', value: '15-' }, { label: '0-', value: '0-' }, { label: 'DEA', value: 'DEA' }] }, headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; const selectedRaw = Array.isArray(headerValue) ? headerValue : (typeof headerValue === 'object' && Array.isArray(headerValue?.value) ? headerValue.value : String(headerValue).split(/[\s,;|]+/)); const selected = selectedRaw.map(s => String(s).trim()).filter(Boolean); if (selected.length === 0) return true; if (selected.includes(t('Common.All'))) return true; const label = resolveIssuanceExpirationBucket(rowData); return selected.includes(label); }, minWidth: 150, widthGrow: 1, formatter: reactFormatter(<ExpirationFormatter/>) },
        { title: t('Common.CertificateDescription'), field: 'record_description', formatter: reactFormatter(<CertDescriptionFormatter/>), headerFilter: 'input', headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; const s = resolveIssuanceDescription(rowData).toString().toLowerCase(); return s.includes(String(headerValue).trim().toLowerCase()); }, minWidth: 200, widthGrow: 1 },
        { title: t('Common.CertificateStatus'), field: 'certificate_status', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: t('Status.Deactivated'), value: "Deaktivovaný" }], placeholder: t('Common.CertificateStatus') }, headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; if (!isCompanyCertificateParentRow(rowData)) return true; const selectedRaw = Array.isArray(headerValue) ? headerValue : (typeof headerValue === 'object' && Array.isArray(headerValue?.value) ? headerValue.value : String(headerValue).split(/[\s,;|]+/)); const selected = selectedRaw.map(s => String(s).trim()).filter(Boolean); if (selected.length === 0) return true; const label = resolveCardDeactivationDate(rowData) ? t('Status.Deactivated') : 'Aktívny'; return selected.includes(label); }, minWidth: 200, formatter: reactFormatter(<CertificateStatusFormatter/>) },
        { title: t('Common.Column.Responsible'), field: 'responsible.name',formatter: reactFormatter(<ResponsibleNameFormatter/>),headerFilter:"input",minWidth: 260, widthGrow:1},
        { title: t('Common.Status'), field: 'state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }], placeholder: t('Common.Status') }, headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; const selectedRaw = Array.isArray(headerValue) ? headerValue : (typeof headerValue === 'object' && Array.isArray(headerValue?.value) ? headerValue.value : String(headerValue).split(/[\s,;|]+/)); const selected = selectedRaw.map(s => String(s).trim()).filter(Boolean); if (selected.length === 0) return true; const label = getStateLabel(rowData); return selected.includes(label); }, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<StateFormatter/>) },
        { title: t('Common.Protocol'), field: 'protocol',headerFilter:"input",minWidth: 200, widthGrow:1,formatter: reactFormatter(<Protocol/>)},
      ]);
      const columns = useMemo(() => [...baseColumns, ...auditTailColumns], [baseColumns, auditTailColumns]);

    const scrollToFirst = () => scrollToFirstUtil(getTable());
    const scrollUp = () => scrollUpUtil(getTable());
    const scrollDown = () => scrollDownUtil(getTable());
    const scrollToLast = () => scrollToLastUtil(getTable());
    
    function setMask(item,value){
      const columnVisible = {...columnsVisible};
        columnVisible[item] = value;
      const table = getTable();
      for(const val in columnVisible) {
        if(columnVisible[val]===false){
          table?.hideColumn?.(`${val}`);
        }
        else{
          table?.showColumn?.(`${val}`);
        }
      }
      setColumnsVisible(columnVisible);
      setTimeout(() => {
        table?.redraw?.(true);
      }, 0);
    }
  
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
  
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: TRAINING_COMPANY_CERT_STATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);



    const defaultColumnsVisible = TRAINING_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE;
    const resetMask = () => resetTabulatorMask({ page: 'TrainingCompanyCertStateList', defaultColumnsVisible, ref, columns, setColumnsVisible });
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              ...(!preview && !preview_period ? [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("TrainingCompanyCertStateList","set_filters",null,readTabulatorHeaderFilterEntries(getTable()),null);},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("TrainingCompanyCertStateList","set_filters",null,[],null);getTable()?.clearHeaderFilter?.();captureHScroll();requestFullProgressiveSessionRestart();},
                template: itemRenderer,
            },
              ] : []),
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("TrainingCompanyCertStateList","set_sorters",null,null,null,getTable()?.getSorters?.() ?? []);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("TrainingCompanyCertStateList","set_sorters",null,null,null,[]);getTable()?.setSort?.([]);captureHScroll();requestFullProgressiveSessionRestart();OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingCompanyCertStateList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
            columnVisible[val]=false;
            ref.current.hideColumn(`${val}`);
          }
        };
        setColumnsVisible(columnVisible);
        setTimeout(() => {
            ref.current.redraw(true);
        }, 0);
    }

    function previewFilter(data, filterParams){
        if(filterParams.time_period=="after"){
          if((data._children.length == 0 || (data._children.length > 0 && new Date(data._children[0].end_of_validity) < new Date()))){
            return true;
          }
        }
        else if(filterParams.time_period=="15"){
          if(data._children.length > 0 && ((new Date(data._children[0].end_of_validity) > new Date()) && (new Date(data._children[0].end_of_validity) <= new Date(new Date().setDate(new Date().getDate() + 15))))){
            return true;
          }
        }
        else if(filterParams.time_period=="30"){
          if(data._children.length > 0 && ((new Date(data._children[0].end_of_validity) > new Date()) && (new Date(data._children[0].end_of_validity) <= new Date(new Date().setDate(new Date().getDate() + 30))))){
            return true;
          }
        }
        else if(filterParams.time_period=="others"){
          if(data._children.length > 0 && (new Date(data._children[0].end_of_validity) > new Date(new Date().setDate(new Date().getDate() + 30)))){
            return true;
          }
        }
        return false;
      }

    function periodSegmentFilter(data, filterParams) {
      const children = (data._children || []).slice().sort((a, b) => new Date(a.start_of_validity || 0) - new Date(b.start_of_validity || 0));
      const dateFrom = filterParams.dateFrom instanceof Date ? filterParams.dateFrom : new Date(filterParams.dateFrom);
      const dateTo = filterParams.dateTo instanceof Date ? filterParams.dateTo : new Date(filterParams.dateTo);
      const wantOnTime = filterParams.segment === 'on_time';
      for (let idx = 0; idx < children.length; idx++) {
        const rec = children[idx];
        const start = rec.start_of_validity ? new Date(rec.start_of_validity) : null;
        const end = rec.end_of_validity ? new Date(rec.end_of_validity) : null;
        if (!start || !end || start > dateTo || end < dateFrom) continue;
        const prev = children[idx - 1];
        const prevEnd = prev && prev.end_of_validity ? new Date(prev.end_of_validity) : null;
        const isOnTime = !prevEnd || start <= prevEnd;
        if (isOnTime === wantOnTime) return true;
      }
      return false;
    }
    
    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button type="button" onClick={() => runCompanyCertPrint()}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor!="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue("");toolbarSearchRef.current="";getTable()?.clearFilter?.();captureHScroll();requestFullProgressiveSessionRestart();}}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button type="button" onClick={() => exportCompanyCertXlsx()}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { getRequest("/api/training_types?minimal=1").then((r) => setTrainingTypesList(r?.data ?? r ?? [])).catch(() => {}); captureHScroll(); requestFullProgressiveSessionRestart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Print.Title.TrainingCompanyCertStateList'),"TrainingCompanyCertStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("TrainingCompanyCertStateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    
    <div ref={elementRef}>
    <div ref={tableContainerRef} className="flex-1 min-h-0 overflow-hidden">
    <ReactTabulator
      key={`training-cert-state-${tableSessionKey}-${preview ?? ''}-${preview_period?.dateFrom ?? ''}-${preview_period?.dateTo ?? ''}`}
      data={undefined}
      onRef={(r) => (ref.current = r?.current ?? r)}
      className='h-[calc(100vh_-_193px)]'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            isRestoringRef.current = true;
            const table = getTable();
            const restartRestore = sessionQueryActiveRef.current;
            if (!table) {
              tableBuiltRef.current = true;
              restartQueuedRef.current = false;
              window.setTimeout(() => {
                isRestoringRef.current = false;
                sessionQueryActiveRef.current = false;
              }, 0);
              return;
            }
            if (preview_period && preview_segment) {
              const dateFrom = new Date(preview_period.dateFrom);
              const dateTo = new Date(preview_period.dateTo);
              table?.setFilter?.(periodSegmentFilter, { dateFrom, dateTo, segment: preview_segment });
            } else if (preview != null) {
              table?.setFilter?.(previewFilter, { time_period: preview });
            }
            const restoreConfirmedFilters = () => {
              (confirmedQueryRef.current.filters || []).forEach((f) => {
                if (!f?.field) return;
                const val = f?.value;
                if (val == null || val === '') return;
                if (f.field === 'custom_expiration' && val === "Všetko") return;
                table?.setHeaderFilterValue?.(f.field, val, true);
              });
              const confirmedSorters = cleanSorters(confirmedQueryRef.current.sorters || []);
              if (confirmedSorters.length > 0) {
                table?.setSort?.(confirmedSorters.map((s) => ({ column: s.field, dir: s.dir })));
              }
            };
            let mask = state.user_mask_filters.filter(mask => mask.page=="TrainingCompanyCertStateList");
            const safeParse = (v, fallback) => {
                if (v === null || v === undefined) return fallback;
                if (typeof v === "string") {
                try { return JSON.parse(v); } catch { return fallback; }
                }
                return v; // už je array/object
            };
            if (mask.length > 0 && !preview && !preview_period) {
                const attributes  = safeParse(mask[0].attributes, []);
                const filters     = safeParse(mask[0].filters, []);
                const sorters     = safeParse(mask[0].sorters, []);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) {
                    table?.setColumnLayout?.(appendAuditFieldsToColumnLayout(attributes));
                }
                if (restartRestore) {
                    restoreConfirmedFilters();
                } else if (Array.isArray(filters)) {
                    filters.forEach(f => {
                      const val = f?.value;
                      if (f.field === 'custom_expiration' && val === "Všetko") return;
                      table?.setHeaderFilterValue?.(f.field, val, true);
                    });
                }
                if (!restartRestore && Array.isArray(sorters) && sorters.length > 0) {
                    table?.setSort?.(sorters);
                }
                if (json_columns && typeof json_columns === "object") {
                    const mergedColumns = mergeColumnVisibilityWithAuditDefaults(
                      TRAINING_COMPANY_CERT_STATE_LIST_DEFAULT_COLUMNS_VISIBLE,
                      json_columns
                    );
                    setColumnsVisible(mergedColumns);
                    for (let column in mergedColumns) {
                        if (mergedColumns[column] === false) table?.hideColumn?.(column);
                        else table?.showColumn?.(column);
                    }
                }
            } else if (restartRestore) {
                restoreConfirmedFilters();
            }
            tableBuiltRef.current = true;
            restartQueuedRef.current = false;
            window.setTimeout(() => {
              isRestoringRef.current = false;
              sessionQueryActiveRef.current = false;
            }, 0);
          },
          headerFilterChanged: () => {
            if (isRestoringRef.current) return;
            captureHScroll();
            requestFullProgressiveSessionRestart();
          },
          sortChanged: () => {
            if (isRestoringRef.current) return;
            captureHScroll();
            requestFullProgressiveSessionRestart();
          },
          renderComplete: () => { restoreHScroll(); },
          columnMoved: () => { setUserMaskFilter("TrainingCompanyCertStateList", "column_move", null, null, getTable()?.getColumnLayout?.()); },
          columnResized: () => { setUserMaskFilter("TrainingCompanyCertStateList", "column_resized", null, null, getTable()?.getColumnLayout?.()); }
      }}
      options={{
      index: 'id',
      renderHorizontal:"virtual",rowHeight:48,layout:"fitColumns",movableColumns: true,resizableColumnFit: true,
      dataTree:true,dataTreeStartExpanded:false,dataTreeFilter:false,dataTreeElementColumn:"company.name",
      dataTreeCollapseElement:ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
      dataTreeExpandElement:ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
      dataTreeBranchElement:ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
      printAsHtml:true,
      printHeader: () => buildCanonicalPrintHeaderHtml({
        branding: state?.branding,
        productFallbackSrc: defaultProductLogoSrc,
        companySettingsPrint: state?.company_settings_print,
        moduleSettings: state?.module_settings,
        title: t('Print.Title.TrainingCompanyCertStateList'),
        printDateLabel: t('Print.DateLabel'),
      }),
      printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
      printRowRange:"active",
      ajaxURL: '/api/company_certificates/paged',
      ajaxRequestFunc,
      filterMode: 'remote',
      sortMode: 'remote',
      pagination: false,
      progressiveLoad: 'scroll',
      progressiveLoadScrollMargin: 80,
      progressiveLoadDelay: 200,
      paginationSize: pageSizePc,
      dataLoader: true,
      dataLoaderLoading: t('Common.LoadingData'),
      dataLoaderError: t('Common.LoadFailed'),
      ajaxRequesting: () => {
        if (pendingInvalidationRef.current && !isTableVisible()) return false;
        if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
        const table = getTable();
        if (table?.initialized) table.alert?.(t('Common.LoadingData'));
        return true;
      },
      ajaxResponse: (url, params, response) => {
        getTable()?.clearAlert?.();
        const next = applyCompanyCertPagedMutationOverlay(response, mutationOverlayRef.current);
        if (next && typeof next === 'object') lastResponseRef.current = next;
        return next;
      },
      ajaxError: () => {
        getTable()?.clearAlert?.();
      },
      }}/>
    </div>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingCompanyCertStateList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
      </div> 
        </>
    )
}